import r from "./extends3.mjs";
import * as e from "react";
import { MuiPickersAdapterContext as a } from "./LocalizationProvider.mjs";
import { DEFAULT_LOCALE as s } from "./enUS.mjs";
const i = () => {
  const t = e.useContext(a);
  if (t === null)
    throw new Error(["MUI: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (t.utils === null)
    throw new Error(["MUI: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const o = e.useMemo(() => r({}, s, t.localeText), [t.localeText]);
  return e.useMemo(() => r({}, t, {
    localeText: o
  }), [t, o]);
}, l = () => i().utils, f = () => i().defaultDates, p = () => i().localeText, m = (t) => {
  const o = l(), n = e.useRef();
  return n.current === void 0 && (n.current = o.dateWithTimezone(void 0, t)), n.current;
};
export {
  f as useDefaultDates,
  p as useLocaleText,
  i as useLocalizationContext,
  m as useNow,
  l as useUtils
};
//# sourceMappingURL=useUtils.mjs.map
